export { logger } from './logger'
export type { LogFunction, Logger } from './shared'
